import { connect } from 'react-redux';
import { getIcon } from 'helpers';
import {
	MenuItem,
	FormControl,
	ListItemIcon,
	TextField,
	Divider,
} from '@mui/material';
import clsx from 'clsx';
import styles from '../editPost.module.css';

export function CategorySelect({
	className,
	children,
	handleChange,
	none,
	style,
	value,
	required,
	categories,
	disabled,
	...props
}) {
	const variant = props.variant
		? { variant: props.variant, label: 'Category' }
		: {};

	const categoryMap =
		categories &&
		Boolean(categories.length) &&
		categories.map((val, i, arr) => {
			const Icon = getIcon(val);
			const isParent = val.id === arr[i + 1]?.parentId;
			const parentClass = isParent ? styles.parentMenuItem : null;

			return [
				isParent && <Divider className={styles.categorySelectDivider} />,
				<MenuItem
					className={clsx(styles.categorySelectMenuItem, parentClass)}
					value={val.id}
					key={val.id}>
					{<ListItemIcon>{Icon ? <Icon /> : null}</ListItemIcon>}
					{val.label}
				</MenuItem>,
			];
		});
	return categories && Boolean(categories.length) ? (
		<FormControl className={className ? className : styles.select}>
			<TextField
				select
				value={value || ''}
				className={styles.select}
				slotProps={{ classes: { input: styles.inputProps } }}
				onChange={handleChange}
				disabled={disabled}
				required={required}
				name='category'
				{...variant}>
				{children}
				<MenuItem value=''>None</MenuItem>
				{categoryMap}
			</TextField>
		</FormControl>
	) : null;
}

const mapStateToProps = ({ lifebooks }) => {
	return {
		categories: lifebooks.categories,
		categoriesHash: lifebooks.categoriesHash,
	};
};

export default connect(mapStateToProps)(CategorySelect);
